/* eslint-disable */
import * as Types from './types';

export type ColorSelectorFragment = { __typename?: 'ColorSelector', title?: string | null, tabs?: { __typename?: 'ColorSelectorColorSelectorTabsCollection', items: Array<{ __typename?: 'ColorSelectorTab', title?: string | null, description?: string | null, products?: { __typename?: 'ColorSelectorTabProductsCollection', items: Array<{ __typename?: 'Product', title?: string | null, handle?: string | null, shadeColor?: string | null } | null> } | null } | null> } | null };

export declare const ColorSelectorFragment: import("graphql").DocumentNode;
export const ColorSelectorFragmentDoc = /*#__PURE__*/ `
    fragment ColorSelectorFragment on ColorSelector {
  title
  tabs: colorSelectorTabsCollection(limit: 3) {
    items {
      title
      description
      products: productsCollection(limit: 40) {
        items {
          title
          handle
          shadeColor
        }
      }
    }
  }
}
    `;